/*
 * Page panier : le contenu est masqué et remplacé par le tiroir, ouvert à l'arrivée. Sortir
 * du tiroir depuis cette page renvoie donc à l'accueil, faute de quoi le visiteur se
 * retrouverait devant une page vide.
 *
 * Deux garde-fous : on attend que `cart-drawer` soit défini (l'élément est chargé en module,
 * donc après le parsing), et on ne redirige pas en mode édition, sinon le customizer serait
 * inutilisable.
 */
(() => {
  const openCartDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    drawer.addEventListener('dialog:before-hide', () => {
      if (window.Shopify && window.Shopify.designMode) return;
      window.location.assign((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    });

    window.customElements.whenDefined('cart-drawer').then(() => {
      if (!drawer.open) drawer.show();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openCartDrawer);
  } else {
    openCartDrawer();
  }
})();
